import { render, staticRenderFns } from "./PaymentMethodInput.vue?vue&type=template&id=973524e2&scoped=true&"
import script from "./PaymentMethodInput.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodInput.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodInput.vue?vue&type=style&index=0&id=973524e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973524e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
